import camelCase from 'lodash/camelCase';
import type { ViewArea } from './viewAreas';

/**
 * Elements a release-note tour can point at. Each tour step in the help center
 * (`tourSteps[].anchor`) names one of these keys, and the element carries it as
 * `data-tour="<key>"`. Published tours reference the keys, so add keys freely but
 * never rename one. The editor-facing list lives in docs/release-note-tours.md.
 */
export const TOUR_ANCHOR_ATTRIBUTE = 'data-tour';

/** Sidebar and mobile tab-bar entries: `nav.<route name in camelCase>`, e.g. `nav.calendar`. */
export const navTourAnchor = (routeName: string) => `nav.${camelCase(routeName)}`;

/** The navigation is the same on every page, so a missing `nav.*` element won't turn up later. */
export const isGlobalTourAnchor = (anchor: string) => anchor.startsWith('nav.');

/** The layout switch in a view area's page header, e.g. `calendar.viewSwitch`. */
export const viewSwitchTourAnchor = (area: ViewArea) => `${area}.viewSwitch`;

export const tourAnchorProps = (anchor: string) => ({ [TOUR_ANCHOR_ATTRIBUTE]: anchor });
